import React from 'react';
const chapters = [{
  chapter: 'The Climate of Intolerance',
  exposes: 'How everyday disagreement was rebranded as a moral crime'
}, {
  chapter: 'The Weapon of Censorship',
  exposes: 'The specific mechanisms used to silence dissenting voices'
}, {
  chapter: 'The Digital Battlefield',
  exposes: 'How social media became the engine of ideological purges'
}, {
  chapter: 'Education & Indoctrination',
  exposes: 'Where the fracture was planted — and in whom'
}, {
  chapter: 'The Charlie Kirk Case',
  exposes: 'The complete documented account of September 10, 2025'
}, {
  chapter: 'The Trial of an Era',
  exposes: 'What the aftermath revealed about American justice'
}, {
  chapter: 'The American Crossroads',
  exposes: 'Where this country stands now — and what comes next'
}];
export function ChapterTableSection() {
  return <section className="w-full bg-editorial-bgAlt py-section-mobile md:py-section-desktop px-6 md:px-8 border-t border-editorial-divider bg-gradient-to-b from-editorial-bgAlt to-editorial-bg" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-editorial-text text-center mb-12" data-id="element-3">
          What You'll Find Inside
        </h2>

        <div className="space-y-4 md:space-y-5" data-id="element-4">
          {chapters.map((row, idx) => <div key={idx} className="border-l-4 border-editorial-accent bg-editorial-card rounded-r-lg px-6 py-5 md:px-8 md:py-6" data-id="element-5">
              <p className="text-base md:text-lg font-sans font-bold text-editorial-text mb-1" data-id="element-6">
                📌 {row.chapter}
              </p>
              <p className="text-sm md:text-base font-sans text-editorial-textMuted leading-relaxed" data-id="element-7">
                {row.exposes}
              </p>
            </div>)}

          {/* Highlighted Epilogue Card */}
          <div className="border-l-4 border-editorial-accent bg-editorial-card rounded-r-lg px-6 py-5 md:px-8 md:py-6 ring-1 ring-editorial-accent/30" data-id="element-8">
            <p className="text-base md:text-lg font-sans font-bold text-editorial-text mb-1" data-id="element-9">
              📌 Exclusive Epilogue
            </p>
            <p className="text-sm md:text-base font-sans font-bold text-editorial-text leading-relaxed" data-id="element-10">
              The Voice That Lives On — The Mandate
            </p>
          </div>
        </div>

        <p className="mt-12 text-center text-editorial-textMuted italic font-serif text-lg md:text-xl" data-id="element-11">
          "The story is already written.
          <br className="hidden md:block" data-id="element-12" />
          The only question is whether you're willing to read it."
        </p>
      </div>
    </section>;
}